import { __rest } from "tslib";
export const parseRedirect = (_a) => {
    var _b, _c;
    var { triggers = [], triggerWithRefinements = false } = _a, item = __rest(_a, ["triggers", "triggerWithRefinements"]);
    return (Object.assign(Object.assign({}, item), { triggerWithRefinements, triggerType: (_c = (_b = triggers[0]) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : '', triggers: triggers.map((trigger) => trigger.value) }));
};
export default parseRedirect;
